import { Box, Icon, IconButton, makeStyles } from "@material-ui/core";
const identification = "header-search";
const useStyles = makeStyles((theme) => ({
    search: {
        color: "inherit",
        borderRadius: theme.shape.borderRadius,
        backgroundColor: "rgba(255, 255, 255, 0.15)",
        "&:hover": { backgroundColor: "rgba(255, 255, 255, 0.25)" },
        margin: theme.spacing(0, 1, 0, 1.5),
        padding: 0,
    },
    searchIcon: {
        padding: "5px 4px 0px 8px",
    },
    inputInput: {
        fontSize: 12,
        padding: "4px 12px 4px 6px",
    },
}));
const HeaderSearchIcon = () => {
    const classes = useStyles();
    const handleClick = () => window.RootExtensions.FullSearchWindow?.open?.();
    return (<IconButton className={classes.search} data-identification={identification} onClick={handleClick}>
      <Box className={classes.searchIcon}>
        <Icon>search</Icon>
      </Box>
      <span className={classes.inputInput}>Search…</span>
    </IconButton>);
};
export default HeaderSearchIcon;
